// import triggerPopup from "../components/_trigger-popup.js";
import "@fancyapps/fancybox";
import responsiveVideo from "../components/_responsive-video";
import toggleModalVideo from "../components/_toggle-video-modal";

responsiveVideo();
toggleModalVideo("youtube");

// triggerPopup("#popup");
